import React, { Component } from 'react'

import { Wrap, Vertical, Horizontal } from './styles'

class PlusMinus extends Component {
  render() {
    return (
      <Wrap active={this.props.active}>
        <Vertical />
        <Horizontal />
      </Wrap>
    )
  }
}

export default PlusMinus



// WEBPACK FOOTER //
// ./src/components/PlusMinus/index.js